<main class="mfa">
  <header>
    <img
      class="logo"
      src="../../../../assets/logos/seat-cupra-logo-white.svg"
      alt="{{ 'altLogo' | i18next }}"
    />
  </header>
  <div class="text-center spinnerADContainer" [hidden]="!spinnerAD">
    <div class="spinner-border spinnerAD" role="status"></div>
  </div>
  <main
    class="authentication"
    *ngIf="!isAD"
    [style]="loginSession ? 'margin-top: 5%' : ''"
  >
    <mat-card class="mfa--card">
      <form
        class="form"
        [formGroup]="authenticationForm"
        [ngClass]="hasQr()"
        (ngSubmit)="codeVerification()"
      >
        <h2 *ngIf="!loginSession">{{ 'userCreation' | i18next }}</h2>
        <h2 *ngIf="loginSession">{{ 'loginUser' | i18next }}</h2>
        <p class="form--subtitle" *ngIf="!loginSession">
          {{ 'mfaTitle' | i18next }}
        </p>
        <!-- código QR -->
        <div
          *ngIf="
            !!sessionInfo.qrCodeResponseDTO &&
            sessionInfo.qrCodeResponseDTO.qrCode
          "
          [hidden]="showSMSOption"
          class="form--qrContainer"
        >
          <img
            [src]="QRCode"
            class="form--qrContainer__img"
            alt="{{ 'altQr' | i18next }}"
          />
        </div>
        <p
          *ngIf="
            !!sessionInfo.qrCodeResponseDTO &&
            sessionInfo.qrCodeResponseDTO.qrCode
          "
          class="form--qrContainer__text"
        >
          {{ secretCode }}
        </p>
        <p
          *ngIf="!!sessionInfo.qrCodeResponseDTO"
          [hidden]="showSMSOption"
          class="form--text"
        >
          {{ 'mfaTextQR' | i18next }}
        </p>
        <!--   <p *ngIf="!!sessionInfo.smsResponseDTO"  [hidden]="showSMSOption" class="form--input__text">{{'mfaTextSMS' | i18next}}</p> -->
        <mat-form-field class="card--content__input">
          <mat-label for="code">{{ 'mfaCode' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="{{ 'mfaCode' | i18next }}"
            formControlName="code"
            #autofocus
          />
        </mat-form-field>
        <app-error-with-guide class="errorMessage" [message]="errorMessage">
        </app-error-with-guide>
        <app-error-with-guide
          class="errorMessage"
          [messageLogin]="loginErrorMessage"
          [showGuideLink]="showDownloadGuideLink"
        >
        </app-error-with-guide>
        <span *ngIf="controlInput('authenCode')" class="error-message">
          <p>{{ 'emailVerificationInputErr' | i18next }}</p>
        </span>
        <mat-card-actions class="btnContainer" [hidden]="showSMSOption">
          <button
            type="button"
            class="btnContainer--btnCancel btn cancel"
            (click)="navigateTo()"
          >
            {{ 'btnCancel' | i18next | uppercase }}
          </button>
          <button
            type="submit"
            class="btnContainer--btn btn confirmDark"
            [disabled]="!authenticationForm.valid"
          >
            {{ 'btnAccept' | i18next | uppercase }}
          </button>
          <div class="text-center spinnerContainer" [hidden]="!spinner">
            <div class="spinner-border spinner" role="status"></div>
          </div>
        </mat-card-actions>
        <!-- <div class="sms-container" *ngIf="showSMSOption">
          <button  type="button" class="btn confirm bgColor smsBtn" [routerLink]="['/register/sms-authentication']">{{'btnSms' | i18next}}</button>
          <small class="text">{{'smsAuthInfoBtn' | i18next | uppercase}}</small>
        </div> -->
      </form>
    </mat-card>
  </main>
  <div class="adError" *ngIf="isAD">
    <p>{{ errorMessage }}</p>
  </div>
</main>
